class PredictiveSearch extends HTMLElement {
	constructor() {
		super()

		this.input = this.querySelector('input[type="search"]')
		this.predictiveSearchResults = this.querySelector('#predictive-search')

		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event)
			}, 300).bind(this)
		)
	}

	onChange() {
		const searchTerm = this.input.value.trim()
		if (!searchTerm.length) {
			this.close()
			return
		}

		this.getSearchResults(searchTerm)
	}

	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status)
					this.close()
					throw error
				}

				return response.text()
			})
			.then((text) => {
				const resultsMarkup = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('#shopify-section-predictive-search').innerHTML

				this.predictiveSearchResults.innerHTML = ''
				if (resultsMarkup.includes('<ul')) {
					this.predictiveSearchResults.innerHTML = `        <div class="search-products__header">
          <p>TOP RESULTS</p>
          </div>`
				}
				this.predictiveSearchResults.innerHTML += resultsMarkup
				this.open()
			})
			.catch((error) => {
				this.close()
				throw error
			})
	}

	open() {
		this.predictiveSearchResults.style.display = 'block'
		const inital_products = document.querySelector('.initial-products-wrapper')
		if (inital_products) {
			inital_products.style.display = 'none'
		}
	}

	close() {
		this.predictiveSearchResults.style.display = 'none'
		const inital_products = document.querySelector('.initial-products-wrapper')
		if (inital_products) {
			inital_products.style.display = 'grid'
		}
	}

	debounce(fn, wait) {
		let t
		return (...args) => {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	}
}

customElements.define('predictive-search', PredictiveSearch)
